import { SunspotLoader } from 'react-awesome-loaders'
import { useState, useEffect, memo, useMemo } from 'react'

import cx from 'classnames'
import { useLocation } from 'react-router-dom'
import { Button, Form } from 'reactstrap'
import { getExamType } from 'utils/common'
import config from 'config'
import { connect } from 'react-redux'
import useGetApi from 'api/useGetApi'
import { changeToIst, webEngageDob } from 'utils/dateTime'
import { usePutPostApi } from 'api/usePutPostApi'
import SelectCreatable from 'utils/SelectDropdown'
import { SET_TOAST_DATA } from 'constants/actionTypes'

import styles from 'components/Registration/Form/signupStyles.module.css'
import MobilePaymentForm from 'components/shared/MobilePaymentForm'
import PaymentForm from 'components/Card/paymentForm'
import infoicon from '../../../assets/fi_info_payment.svg'
import ApplyCoupon from 'components/Card/CouponCode'

const mapDispatchToProps = (dispatch) => ({
    setToastMsgsData: (payload) => {
        dispatch({ type: SET_TOAST_DATA, payload })
    },
})

const StepThreeExamInfo = ({
    userInfo,
    userMethod,
    isUserInfoValid,
    setToastMsgsData,
    setSignupSuccessDetails,
    examInfo,
    setExamInfo,
    dropdownOptions,
    setDropdownOptions,
    errors,
    getSelectDefaultValue,
    handleOnChange,
    handleUpdateErrors,
    registration_page,
    handleErrorsOnChangeCourseType,
    partialData,
    getNearestCentre,
    isSfNewUser,
}) => {
    let examMode
    const centreCode =
        examMode == 'Online' && examType === 'IAT'
            ? examInfo?.coachingBranch?.centreCode
            : examInfo?.centre?.centreCode

    const hostname = typeof window !== 'undefined' ? window.location.hostname : ''
    const isDigital = hostname?.includes('aakashdigital.com')
    const [paymentMethod, setPaymentMethod] = useState('')
    const [hasTracked, setHasTracked] = useState(false)
    const [removeCoupon, setRemoveCoupon] = useState(0)
    const [checkMock, setCheckMock] = useState(false)
    const [coupon, setCoupon] = useState('')
    const examType = getExamType()
    const queryString = window.location.href
    const [couponCode, setCouponCode] = useState('')
    const url = new URL(queryString)
    const handlePaymentMethod = (e) => {
        let name = e.target.value.toLowerCase()
        if (examType == 'MOCK-NEET' || examType == 'IAT' || examType == 'MOCK-JEE') {
            window.webengage.track(examType + '5_payment', {
                'utm parameters': utmParams ? utmParams : '',
                method: userMethod.isPsid ? 'psid' : 'mobile',
                'mobile number': userInfo.mobileNumber ? userInfo.mobileNumber : '',
                board: examInfo.schoolBoard.value ? examInfo.schoolBoard.value : '',
                course_type: courseType ? 'Classroom' : 'Aakash Digital',
                student_name: userInfo.studentName ? userInfo.studentName : '',
                dob: webEngageDob(userInfo.dob) ? webEngageDob(userInfo.dob) : '',
                email_ID: userInfo.email ? userInfo.email : '',
                class: examInfo.classStream.class ? examInfo.classStream.class : '',
                stream: examInfo.classStream.stream
                    ? examInfo.classStream.stream
                    : '',
                city: userInfo.city ? userInfo.city : '',
                psid: userMethod.psid ? userMethod.psid : '',
                pincode: userInfo.pincode ? userInfo.pincode : '',
                state: userInfo.state ? userInfo.state : '',
                exam_mode: examInfo?.examSlots?.label,
                exam_type: examType,
                exam_state: examInfo.state.label ? examInfo.state.label : '',
                'Branch name':
                    examType !== 'IAT'
                        ? examInfo?.centre?.label
                        : examInfo?.examSlots?.label?.startsWith('Online')
                          ? examInfo?.coachingState?.label
                          : examInfo?.state?.label,
                'Branch code':
                    examType !== 'IAT'
                        ? examInfo?.centre?.centreCode
                        : examInfo?.examSlots?.label?.startsWith('Online')
                          ? examInfo?.coachingBranch.centreCode
                          : examInfo?.centre?.centreCode,
                'Study Center name': examInfo?.coachingBranch?.label,
                'Study Center code': examInfo?.coachingBranch?.centreCode,
                exam_date: new Date(examInfo.dateOfExam.value + 'T03:30:00.000Z')
                    ? new Date(examInfo.dateOfExam.value + 'T03:30:00.000Z')
                    : '',
                'payment method': name,
                exam_fee: partialData?.data.exam_fee
                    ? Number(partialData.data.exam_fee) - removeCoupon
                    : 0,
                coupon_code: coupon,
            })
        }

        setPaymentMethod(name)
    }

    const [filteredFormValues, setfilteredFormValues] = useState({})
    const isNeetMockRoute = 'MOCK-NEET' === examType

    const isInvictusRoute = 'IAT' === examType

    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const student_sf_id = queryParams.get('sf_id')

    const isAdst = location.pathname.includes('/adst')
    if (isAdst) {
        examMode = 'Online'
    }
    const [courseType, setCourseType] = useState(true)

    const utmParams = JSON.parse(sessionStorage.getItem('utmParams'))

    const [isFormValid, setIsFormValid] = useState(false)

    const [showToast, setShowToast] = useState(0)

    if (examInfo?.examSlots?.label?.includes('Online')) {
        examMode = 'Online'
    } else if (examInfo?.examSlots?.label?.includes('Offline')) {
        examMode = 'Offline'
    }

    const isSubIacstExam = window.location.pathname === '/iacst-exam'
    let isCheckedState = true
    let api_url =
        config.FETCH_EXAM_STATE +
        '/?class_stream=' +
        examInfo.classStream.value +
        '&exam_mode=' +
        examMode

    if (isSubIacstExam) {
        api_url += `&isCheckedState=${isCheckedState}`
    }
    const { data: examStatesData, setEnabled: fetchStates } = useGetApi(
        api_url,
        '',
        false,
    )

    const { data: examSlotsData } = useGetApi(`${config.FETCH_EXAM_SLOTS}`, '', true)

    const [storedStudentInfo, setStoredStudentInfo] = useState(
        JSON.parse(localStorage.getItem('studentInfo')) || {},
    )

    const onSuccessfulRegistration = (response) => {
        if (response.isPaidExam) {
            setfilteredFormValues(response)
        } else {
            setSignupSuccessDetails({
                isSignupSuccessful: true,
                ...response,
                exam_date: signupPayload.exam_date,
            })
        }

        const {
            dob, //dd-mm-yyyy
            roll_number,
            dashboard_link: dashboard_autologin_url,
            branch_phone_numbers,
            branch_gps,
            branch_address,
            gps_link,
        } = response

        const {
            studentName: student_name,
            // fatherName: father_name,
            email: email_ID,
            mobileNumber,
            pincode: student_pincode,
            city: student_city,
            state: student_state,
            prevSignupAttempt,
        } = userInfo

        const { classStream, state, centre, dateOfExam, schoolBoard } = examInfo
        const [class_opted, stream] = classStream.stream.split('&')

        //web-analytics
        if (examType == 'iACST') {
            window.webengage.track('iACST_4_Thank_You_Page', {
                'utm parameters': utmParams,
                method: userMethod.isPsid ? 'psid' : 'mobile',
                'mobile number': mobileNumber,
                board: schoolBoard.value,
                course_type: courseType
                    ? 'Classroom'
                    : centre?.centreCode == 'IC006'
                      ? 'ICON'
                      : 'Aakash Digital',
                student_name,
                // father_name,
                dob,
                email_ID,
                class_opted,
                stream,
                student_city,
                student_pincode,
                student_state,
                exam_mode: 'Online',
                exam_state: state.label,
                exam_centre:
                    centre?.centreCode == 'IC006'
                        ? 'Aakash Live - Test'
                        : centre.label,
                exam_centre_code: centre?.centreCode,
                exam_date: new Date(dateOfExam.value + 'T03:30:00.000Z'), // 9AM time
                num_attempt: prevSignupAttempt + 1, //value can be 1-2 including current
                roll_number,
                dashboard_password: dob,
                dashboard_autologin_url,
                branch_phone_numbers,
                branch_gps,
                branch_address,
                gps_link,
            })
        }
    }

    const handleSubmitIacst = () => {
        callSignupApi(true)

        const {
            studentName: student_name,
            // fatherName: father_name,
            email: email_ID,
            dob,
            mobileNumber,
            prevSignupAttempt,
            pincode: student_pincode,
            city: student_city,
            state: student_state,
        } = userInfo

        const { classStream, state, centre, dateOfExam, schoolBoard } = examInfo
        const [class_opted, stream] = classStream.stream.split('&')

        // web-analytics
        if (examType == 'MOCK-NEET' || examType == 'IAT' || examType == 'MOCK-JEE') {
            localStorage.setItem('user_info', JSON.stringify(userInfo))
            localStorage.setItem('exam_info', JSON.stringify(examInfo))
            localStorage.setItem(
                'exam_fee',
                partialData?.data.exam_fee
                    ? Number(partialData.data.exam_fee) - removeCoupon
                    : '',
            )
            localStorage.setItem('exam_mode', examInfo?.examSlots?.label)
            window.webengage.track(examType + '4_Exam_Details', {
                'utm parameters': utmParams ? utmParams : '',
                method: userMethod.isPsid ? 'psid' : 'mobile',
                'mobile number': userInfo.mobileNumber ? userInfo.mobileNumber : '',
                board: examInfo.schoolBoard.value ? examInfo.schoolBoard.value : '',
                course_type: courseType ? 'Classroom' : 'Aakash Digital',
                student_name: userInfo.studentName ? userInfo.studentName : '',
                dob: webEngageDob(dob) ? webEngageDob(dob) : '', // dd-mm-yyyy
                email: userInfo.email ? userInfo.email : '',
                class: examInfo.classStream.class ? examInfo.classStream.class : '',
                pincode: userInfo.pincode ? userInfo.pincode : '',
                city: userInfo.city ? userInfo.city : '',
                state: userInfo.state ? userInfo.state : '',
                exam_mode: examInfo?.examSlots?.label,
                exam_state: examInfo.state.label ? examInfo.state.label : '',
                'branch name':
                    examType !== 'IAT'
                        ? examInfo?.centre?.label
                        : examInfo?.examSlots?.label?.startsWith('Online')
                          ? examInfo?.coachingState?.label
                          : examInfo?.state?.label,
                'Branch code':
                    examType !== 'IAT'
                        ? examInfo?.centre?.centreCode
                        : examInfo?.examSlots?.label?.startsWith('Online')
                          ? examInfo?.coachingBranch.centreCode
                          : examInfo?.centre?.centreCode,
                exam_date: new Date(dateOfExam.value + 'T03:30:00.000Z')
                    ? new Date(dateOfExam.value + 'T03:30:00.000Z')
                    : '',
                exam_type: examType,
                psid: userMethod.psid ? userMethod.psid : '',
                exam_fee: partialData?.data.exam_fee
                    ? Number(partialData.data.exam_fee) - removeCoupon
                    : '',
                coupon_code: localStorage.getItem('coupon_code')
                    ? localStorage.getItem('coupon_code')
                    : '',
                'Study Center name': examInfo?.coachingBranch?.label,
                'Study Center code': examInfo?.coachingBranch?.centreCode,
            })
            if (examType === 'IAT') {
                window.dataLayer.push({
                    event: 'study_center_exam_info',
                    study_center_code: examInfo?.coachingBranch?.centreCode,
                    study_state: examInfo?.coachingState?.shortCode,
                    exam_state: examInfo?.examSlots?.label?.startsWith('Online')
                        ? examInfo?.coachingState?.shortCode
                        : examInfo?.state?.shortCode,
                    exam_center: examInfo?.examSlots?.label?.startsWith('Online')
                        ? examInfo?.coachingBranch?.centreCode
                        : examInfo?.centre?.centreCode,
                })
            }
        } else {
            window.webengage.track('iACST_3_Exam_Details', {
                'utm parameters': utmParams,
                method: userMethod.isPsid ? 'psid' : 'mobile',
                'mobile number': mobileNumber,
                board: schoolBoard.value,
                course_type: courseType
                    ? 'Classroom'
                    : centre?.centreCode == 'IC006'
                      ? 'ICON'
                      : 'Aakash Digital',
                student_name,
                // father_name,
                dob: webEngageDob(dob), // dd-mm-yyyy
                email_ID,
                class_opted,
                stream,
                student_city,
                student_pincode,
                student_state,
                exam_mode: 'Online',
                exam_state: state.label,
                exam_centre:
                    centre?.centreCode == 'IC006'
                        ? 'Aakash Live - Test'
                        : centre.label,
                exam_centre_code: centre?.centreCode,
                exam_date: new Date(dateOfExam.value + 'T03:30:00.000Z'), // 9AM time
                num_attempt: prevSignupAttempt + 1, //value can be 1-2 including current
                'Study Center name': examInfo?.coachingBranch?.label,
                'Study Center code': examInfo?.coachingBranch?.centreCode,
            })
        }
    }

    const Loader = (
        <SunspotLoader
            gradientColors={['#4039d4', '#E0E7FF']}
            size={'10px'}
            desktopSize={'10px'}
            className="m-auto"
        />
    )

    const isSubmitBtnDisabled = !isFormValid || !isUserInfoValid

    const handleRadioClick = (courseType) => {
        handleErrorsOnChangeCourseType()
        if (courseType) {
            setDropdownOptions((s) => ({
                ...s,
                centre: [],
                dateOfExam: [],
            }))
            setExamInfo((s) => ({
                ...s,
                state: '',
                centre: '',
                dateOfExam: '',
            }))
        } else {
            setExamInfo((s) => ({
                ...s,
                state: {
                    label: 'Delhi',
                    shortCode: 'DL',
                    value: 18,
                },
                centre: {
                    centreCode: 'IC006',
                    label: 'Delhi-Janak Puri Branch test',
                    value: 'DelhiJanak Puri Branch test-JP001-14130',
                },
                dateOfExam: '',
            }))

            setCourseType(courseType)
            setShowToast(0)
            fetchCentrePayment(true)
            fetchExamDates(true)
        }
    }

    const toggleToast = (toastIndex) => {
        setShowToast(showToast === toastIndex ? 0 : toastIndex)
    }

    let isCheckedCentre_value = true
    const {
        data: examCentresData,
        error: examCentreError,
        setEnabled: fetchExamCentres,
    } = useGetApi(
        `${config.FETCH_EXAM_CENTRE}/${examMode}/${examInfo.state?.value}/${examInfo.classStream.value}/${isSubIacstExam ? `?isCheckedCentre=${isCheckedCentre_value}` : ''}`,
        '',
        false,
    )

    const {
        data: coachingCentresData,
        error: coachingCentreError,
        setEnabled: fetchCoachingCentres,
    } = useGetApi(
        `${config.FETCH_EXAM_CENTRE}/${examMode}/${examInfo?.coachingState?.value}/${examInfo.classStream.value}/${isSubIacstExam ? `?isCheckedCentre=${isCheckedCentre_value}` : ''}`,
        '',
        false,
    )

    const {
        data: examDatesData,
        error: examDateError,
        setEnabled: fetchExamDates,
    } = useGetApi(
        `${config.FETCH_EXAM_DATE}/${(examMode == 'Online' && examType === 'IAT' ? examInfo?.coachingBranch?.centreCode : examInfo?.centre?.centreCode)}/${examInfo.classStream.stream}?exam_mode=${examMode}`,
        '',
        false,
    )

    const { data: branchPaymentData, setEnabled: fetchCentrePayment } = useGetApi(
        config.FETCH_CENTRE_PAYMENT +
            '/?branch_code=' +
            (examMode == 'Online' && examType === 'IAT' ? examInfo?.coachingBranch?.centreCode : examInfo?.centre?.centreCode),
        '',
        false,
    )

    // POST API for user registration
    const signupPayload = useMemo(
        () => ({
            student_name: userInfo.studentName,
            father_name: userInfo.fatherName,
            student_email: userInfo.email.toLowerCase(),
            student_dob: changeToIst(userInfo.dob),
            student_mobile_no: userInfo.mobileNumber,
            school_board: examInfo.schoolBoard.value,
            class_stream: examInfo.classStream.value,
            exam_state:
                examType !== 'IAT'
                    ? examInfo?.state?.value
                    : examInfo?.examSlots?.label?.startsWith('Online')
                      ? examInfo?.coachingState?.value
                      : examInfo?.state?.value,
            branch_code: isDigital
                ? 'IC006'
                : examType !== 'IAT'
                  ? examInfo?.centre?.centreCode
                  : examInfo?.examSlots?.label?.startsWith('Online')
                    ? examInfo?.coachingBranch?.centreCode
                    : examInfo?.centre?.centreCode,
            exam_date: examInfo.dateOfExam.value,
            student_city: userInfo.city,
            student_state: userInfo.state,
            student_pincode: userInfo.pincode,
            exam_mode: examInfo?.examSlots?.label,
            coachingBranch: examInfo?.coachingBranch?.centreCode,
            coachingState: examInfo?.coachingState?.shortCode,
            whatsapp_status: true, //! whatsapp_optin always `true`
            registration_page,
            ...utmParams,
            gclid: localStorage.getItem('gclid') || '',
            ...(paymentMethod && { payment_mode: paymentMethod }),
            ...(couponCode && { coupon_code: couponCode }), // Include coupon code if available
            ...(student_sf_id && { student_sf_id: student_sf_id }),
        }),
        [
            couponCode,
            examInfo?.centre?.centreCode,
            examInfo.classStream.value,
            examInfo?.coachingBranch?.centreCode,
            examInfo?.coachingState?.shortCode,
            examInfo?.coachingState?.value,
            examInfo.dateOfExam.value,
            examInfo?.examSlots?.label,
            examInfo.schoolBoard.value,
            examInfo?.state?.value,
            examType,
            isDigital,
            paymentMethod,
            registration_page,
            student_sf_id,
            userInfo.city,
            userInfo.dob,
            userInfo.email,
            userInfo.fatherName,
            userInfo.mobileNumber,
            userInfo.pincode,
            userInfo.state,
            userInfo.studentName,
            utmParams,
        ],
    )

    const {
        data: signupData,
        loading: isSignupLoading,
        error: signupError,
        setPutEnabled: callSignupApi,
    } = usePutPostApi(config.SIGNUP_API, '', 'post', signupPayload, false)

    useEffect(() => {
        const handleStorageChange = () => {
            setStoredStudentInfo(
                JSON.parse(localStorage.getItem('studentInfo')) || {},
            )
        }
        window.addEventListener('storage', handleStorageChange)
        return () => window.removeEventListener('storage', handleStorageChange)
    }, [])

    useEffect(() => {
        const storedCoachingState = storedStudentInfo?.coachingState

        const storedCoachingBranch = storedStudentInfo?.coachingBranch

        const storedExamSlots = storedStudentInfo.exam_mode || ''

        const storedState = storedStudentInfo.exam_state || ''

        const storedCenter = storedStudentInfo.branch_code || ''

        const storedExamDate = storedStudentInfo.date_of_exam || ''

        if (examType === 'IAT' && dropdownOptions.coachingStates?.length > 0) {
            const matchedState =
                dropdownOptions.coachingStates.find(
                    (option) =>
                        option?.shortCode?.toLowerCase() ===
                        storedCoachingState?.toLowerCase(),
                ) || null
            if (matchedState) {
                setDropdownOptions((prevOptions) => ({
                    ...prevOptions,
                    coachingStates: [matchedState],
                }))
            }
        }

        if (examType === 'IAT' && dropdownOptions.coachingBranches?.length > 0) {
            const matchedBranch =
                dropdownOptions.coachingBranches.find(
                    (option) =>
                        option?.centreCode?.toLowerCase() ===
                        storedCoachingBranch?.toLowerCase(),
                ) || null
            if (matchedBranch) {
                setDropdownOptions((prevOptions) => ({
                    ...prevOptions,
                    coachingBranches: [matchedBranch],
                }))
            }
        }

        if (dropdownOptions.examSlots.length > 0) {
            const matchedExamSlots =
                dropdownOptions.examSlots.find(
                    (option) =>
                        option.label.toLowerCase() ===
                            storedExamSlots.toLowerCase() ||
                        option.value.toString() === storedExamSlots,
                ) || null
            if (matchedExamSlots) {
                // setExamInfo((s) => ({
                // ...s,
                // examSlots: storedExamSlots
                // }))
                setDropdownOptions((prevOptions) => ({
                    ...prevOptions,

                    examSlots: [matchedExamSlots], // Set as a single object array
                }))
            }
        }

        if (dropdownOptions.state.length > 0) {
            const matchedState =
                dropdownOptions.state.find(
                    (option) =>
                        option.shortCode.toLowerCase() === storedState.toLowerCase(),
                ) || null

            if (matchedState) {
                setDropdownOptions((prevOptions) => ({
                    ...prevOptions,

                    state: [matchedState], // Set as a single object array
                }))
            }
        }

        if (dropdownOptions.centre.length > 0) {
            const matchedCentre =
                dropdownOptions.centre.find(
                    (option) =>
                        option.centreCode.toLowerCase() ===
                        storedCenter.toLowerCase(),
                ) || null

            if (matchedCentre) {
                setDropdownOptions((prevOptions) => ({
                    ...prevOptions,

                    centre: [matchedCentre], // Set as a single object array
                }))
            }
        }

        if (dropdownOptions.dateOfExam.length > 0) {
            const matchedExamDates =
                dropdownOptions.dateOfExam.find(
                    (option) =>
                        option.value.toLowerCase() === storedExamDate.toLowerCase(),
                ) || null

            if (matchedExamDates) {
                setDropdownOptions((prevOptions) => ({
                    ...prevOptions,

                    dateOfExam: [matchedExamDates], // Set as a single object array
                }))
            }
        }
    }, [
        storedStudentInfo,
        dropdownOptions.examSlots.length,
        dropdownOptions.state.length,
        dropdownOptions.centre.length,
        dropdownOptions.dateOfExam.length,
        dropdownOptions?.coachingStates?.length,
        dropdownOptions?.coachingBranch?.length,
    ])

    useEffect(() => {
        if (
            examInfo?.state?.value &&
            examMode &&
            courseType &&
            examType == 'MOCK-NEET'
        ) {
            fetchExamCentres(true)
        }
    }, [examInfo?.state?.value, examMode, courseType])

    useEffect(() => {
        if (!branchPaymentData?.data) return

        const paymentData = branchPaymentData.data

        // 1️ Find primary account (if exists)
        const primaryEntry = Object.entries(paymentData).find(
            ([_, value]) => value.is_primary_account === true,
        )

        if (primaryEntry) {
            // Use primary account directly
            const [primaryKey] = primaryEntry
            setPaymentMethod(primaryKey)
            console.log(paymentMethod)
            return
        }

        // Fallback logic (no primary account found)
        const paymentMethods = Object.keys(paymentData)

        if (paymentMethods.includes('icici')) {
            setPaymentMethod('icici')
        } else if (paymentMethods.includes('hdfc')) {
            setPaymentMethod('hdfc')
        } else if (paymentMethods.includes('paytm')) {
            setPaymentMethod('paytm')
        }
    }, [branchPaymentData])

    useEffect(() => {
        if (isAdst) {
            handleRadioClick(false)
            setCourseType(false)
        }
    }, [isAdst])

    useEffect(() => {
        if (examInfo?.examSlots?.label) {
            localStorage.setItem('exam_slots', examInfo.examSlots.label)
        }
    }, [examInfo?.examSlots?.label])
    useEffect(() => {
        localStorage.setItem('coupon_code', coupon)
    }, [coupon])

    useEffect(() => {
        if (!examInfo.autoFill && examInfo.state && courseType) {
            fetchExamCentres(true)
        }
    }, [courseType, examInfo.autoFill, examInfo.state, examMode])

    useEffect(() => {
        if (
            !examInfo.autoFill &&
            examInfo.coachingState &&
            courseType &&
            examType === 'IAT'
        ) {
            fetchCoachingCentres(true)
        }
    }, [courseType, examInfo.autoFill, examInfo.coachingState, examMode])

    useEffect(() => {
        if (!examInfo.autoFill && examInfo.centre && courseType) {
            fetchCentrePayment(true)
            fetchExamDates(true)
        }
    }, [courseType, examInfo.autoFill, examInfo.centre, examMode])

    useEffect(() => {
        if (
            !examInfo.autoFill &&
            examInfo.state &&
            examInfo.centre &&
            examInfo.dateOfExam
        ) {
            fetchCentrePayment(true)
            fetchExamDates(true)
        }
    }, [examInfo.autoFill, examInfo.centre, examInfo.state, examInfo.classStream])

    useEffect(() => {
        if (examInfo.coachingBranch?.centreCode) {
            fetchCentrePayment(true)
            fetchExamDates(true)
        }
    }, [examInfo.coachingBranch])

    useEffect(() => {
        if (examStatesData?.status && examStatesData?.data.length) {
            const examStatesOptions = examStatesData.data.map(
                ({ tid, shortCode, stateName, coachingState }) => ({
                    label: stateName,
                    coachingState: coachingState,
                    value: tid,
                    shortCode,
                }),
            )

            if (examInfo.autoFill) {
                setExamInfo((s) => ({
                    ...s,
                    state: examStatesOptions.find(
                        ({ shortCode }) => s.autoFill.state === shortCode,
                    ),
                    // coachingState:  examStatesOptions.filter((item) => item.coachingState).find(
                    //         ({ shortCode }) => s.autoFill.state === shortCode,
                    //     )
                }))

                if (examStatesOptions.length === 1) {
                    const singleState = examStatesOptions[0]

                    setExamInfo((prev) => ({
                        ...prev,
                        state: singleState,
                    }))

                    if (examStatesOptions.length === 1) {
                        const singleState = examStatesOptions[0]

                        setExamInfo((prev) => ({
                            ...prev,
                            state: singleState,
                        }))

                        fetchExamCentres(true)
                    }

                    if (examInfo.state) fetchExamCentres(true)
                    if (examType === 'IAT') fetchCoachingCentres(true)
                }

                setDropdownOptions((s) => ({
                    ...s,
                    state: examStatesOptions,
                    coachingStates: examStatesOptions.filter(
                        (item) => item.coachingState,
                    ),
                }))
            }
        }
    }, [examInfo.autoFill, examStatesData, examMode])

    useEffect(() => {
        if (examSlotsData?.success && examSlotsData?.data.length) {
            const examSlotsOptions = examSlotsData.data.map(({ tid, name }) => ({
                label: name,
                value: tid,
            }))

            if (examInfo?.autoFill?.examSlots) {
                let examSlots
                setExamInfo((s) => {
                    examSlots = examSlotsOptions.find(
                        ({ label }) => s.autoFill.examSlots === label,
                    )
                    return { ...s, examSlots }
                })
            }

            if (examType == 'MOCK-NEET') {
                // Automatically select first slot
                if (!examInfo.examSlots && examSlotsOptions.length > 0) {
                    setExamInfo((prev) => ({
                        ...prev,
                        examSlots: examSlotsOptions[0],
                    }))
                }
            }

            setDropdownOptions((s) => ({
                ...s,
                examSlots: examSlotsOptions,
            }))
            if (examMode !== undefined && dropdownOptions.state.length === 0) {
                fetchStates(true)
            }
        }
    }, [examInfo.autoFill, examSlotsData, examMode, examInfo.classStream.value])

    useEffect(() => {
        if (examCentresData?.success && examCentresData?.data.length) {
            const examCentreOptions = examCentresData.data
                .map(({ label, value }) => {
                    const centreCode = value.split('-')[1]
                    if (centreCode !== 'IC006') {
                        // Remove RCC, F+EC, ALC from label and start/center/end patterns
                        const cleanedLabel = label
                            .replace(/(RCC|F\+EC|ALC|F \+ EC)(\s*-\s*|\s+|$)/g, '')
                            .replace(/\s*-\s*$/g, '') // to remove trailing dash if any
                        return {
                            label: cleanedLabel,
                            value,
                            centreCode,
                        }
                    }
                    return undefined
                })
                .filter((d) => d)

            if (
                examCentreOptions.length === 1 &&
                !examInfo?.centre &&
                !examInfo?.autoFill?.centre
            ) {
                const singleCentre = examCentreOptions[0]

                setExamInfo((s) => ({
                    ...s,
                    centre: singleCentre,
                }))

                fetchCentrePayment(true)
                fetchExamDates(true)
            }

            if (examInfo?.autoFill?.centre) {
                let centre
                const hostname = window.location.hostname
                if (!hostname.includes('aakashdigital.com')) {
                    setExamInfo((s) => {
                        centre = {
                            centreCode: 'IC006',
                            label: 'Delhi-Janak Puri Branch test',
                            value: 'DelhiJanak Puri Branch test-JP001-14130',
                        }
                        return { ...s, centre }
                    })
                } else {
                    setExamInfo((s) => {
                        centre = examCentreOptions.find(
                            ({ label }) => s.autoFill.centre === label,
                        )
                        return { ...s, centre }
                    })
                }
                if (centre) {
                    fetchCentrePayment(true)
                    fetchExamDates(true)
                }
            }

            setDropdownOptions((s) => ({
                ...s,
                centre: examCentreOptions,
            }))
            setCheckMock(false)
            // getNearestCentre(true)
        } else if (!examCentresData?.data.length) {
            setDropdownOptions((s) => ({
                ...s,
                centre: [],
                dateOfExam: [],
            }))

            if (examType == 'MOCK-NEET') {
                setCheckMock(true)
            }
        }
    }, [examInfo.autoFill, examCentresData])

    useEffect(() => {
        if (coachingCentresData?.success && coachingCentresData?.data.length) {
            const coachingCentreOptions = coachingCentresData.data
                .map(({ label, value, coachingBranch }) => {
                    const centreCode = value.split('-')[1]
                    if (centreCode !== 'IC006') {
                        // Remove RCC, F+EC, ALC from label and start/center/end patterns
                        const cleanedLabel = label
                            .replace(/(RCC|F\+EC|ALC|F \+ EC)(\s*-\s*|\s+|$)/g, '')
                            .replace(/\s*-\s*$/g, '') // to remove trailing dash if any
                        return {
                            label: cleanedLabel,
                            value,
                            centreCode,
                            coachingBranch: coachingBranch,
                        }
                    }
                    return undefined
                })
                .filter((d) => d)

            if (examInfo?.autoFill?.centre) {
                let centre
                setExamInfo((s) => {
                    centre = coachingCentreOptions.find(
                        ({ label }) => s.autoFill.centre === label,
                    )
                    return { ...s, centre }
                })

                if (centre) {
                    fetchCentrePayment(true)
                    fetchExamDates(true)
                }
            }

            setDropdownOptions((s) => ({
                ...s,
                coachingBranches: coachingCentreOptions.filter(
                    (item) => item.coachingBranch,
                ),
            }))
            // getNearestCentre(true)
        } else if (!coachingCentresData?.data.length) {
            setDropdownOptions((s) => ({
                ...s,
                centre: [],
                dateOfExam: [],
            }))
        }
    }, [examInfo.autoFill, coachingCentresData])

    useEffect(() => {
        if (examDatesData?.success) {
            setDropdownOptions((s) => ({
                ...s,
                dateOfExam: examDatesData.data,
            }))
        }
    }, [examDatesData])

    useEffect(() => {
        if (examDatesData?.success) {
            setDropdownOptions((s) => ({
                ...s,
                dateOfExam: examDatesData.data,
            }))
        }
    }, [examDatesData])

    useEffect(() => {
        if (examCentreError)
            setDropdownOptions((s) => ({
                ...s,
                centre: [],
                dateOfExam: [],
            }))

        if (examDateError)
            setDropdownOptions((s) => ({
                ...s,
                dateOfExam: [],
            }))
    }, [examCentreError, examDateError])

    useEffect(() => {
        // will call onTouch of select dropdown fields
        const examInfoValues = Object.entries(examInfo)
            .filter(([key]) =>
                examType === 'IAT'
                    ? key !== 'state' &&
                      key !== 'centre' &&
                      examInfo?.examSlots?.label?.startsWith('Online')
                    : key !== 'coachingState' && key !== 'coachingBranch',
            )
            .some(([_, val]) => val === '')

        const errorValues = Object.values(errors).some((val) => val)

        // set to `true` when examInfo form is completed with no errors
        setIsFormValid(!examInfoValues && !errorValues)
    }, [examInfo, errors])

    useEffect(() => {
        if (signupData?.success && signupData?.data) {
            onSuccessfulRegistration(signupData.data)
        } else if ((signupData && !signupData?.status) || signupError)
            setToastMsgsData({
                isToastOpen: true,
                toastType: 'error',
                toastMessage:
                    signupData?.msg ||
                    signupError.msg ||
                    'We are facing technical issues. Please try after some time.',
            })
    }, [signupData, signupError])

    useEffect(() => {
        if (examType == 'MOCK-NEET' || examType == 'IAT' || examType == 'MOCK-JEE') {
            if (!hasTracked) {
                setTimeout(() => {
                    localStorage.setItem(
                        'exam_fee',
                        partialData?.data.exam_fee ? partialData.data.exam_fee : '',
                    )
                    // Run your WebEngage tracking code here
                    window.webengage.track(examType + '5_payment', {
                        'utm parameters': utmParams ? utmParams : '',
                        method: userMethod.isPsid ? 'psid' : 'mobile',
                        'mobile number': userInfo.mobileNumber
                            ? userInfo.mobileNumber
                            : '',
                        board: examInfo.schoolBoard.value
                            ? examInfo.schoolBoard.value
                            : '',
                        course_type: courseType ? 'Classroom' : 'Aakash Digital',
                        student_name: userInfo.studentName
                            ? userInfo.studentName
                            : '',
                        dob: webEngageDob(userInfo.dob)
                            ? webEngageDob(userInfo.dob)
                            : '',
                        email_ID: userInfo.email ? userInfo.email : '',
                        class: examInfo.classStream.class
                            ? examInfo.classStream.class
                            : '',
                        stream: examInfo.classStream.stream
                            ? examInfo.classStream.stream
                            : '',
                        city: userInfo.city ? userInfo.city : '',
                        pincode: userInfo.pincode ? userInfo.pincode : '',
                        state: userInfo.state ? userInfo.state : '',
                        exam_mode: examInfo?.examSlots?.label,
                        exam_type: examType,
                        exam_state: examInfo.state.label ? examInfo.state.label : '',
                        'Branch name':
                            examType !== 'IAT'
                                ? examInfo?.centre?.label
                                : examInfo?.examSlots?.label?.startsWith('Online')
                                  ? examInfo?.coachingState?.label
                                  : examInfo?.state?.label,
                        'Branch code':
                            examType !== 'IAT'
                                ? examInfo?.centre?.centreCode
                                : examInfo?.examSlots?.label?.startsWith('Online')
                                  ? examInfo?.coachingBranch.centreCode
                                  : examInfo?.centre?.centreCode,
                        'Study Center name': examInfo?.coachingBranch?.label,
                        'Study Center code': examInfo?.coachingBranch?.centreCode,
                        exam_date: new Date(
                            examInfo.dateOfExam.value + 'T03:30:00.000Z',
                        )
                            ? new Date(examInfo.dateOfExam.value + 'T03:30:00.000Z')
                            : '',
                        'payment method': 'paytm',
                        exam_fee: partialData?.data.exam_fee
                            ? Number(partialData.data.exam_fee) - removeCoupon
                            : 0,
                        psid: userMethod.psid ? userMethod.psid : '',
                        coupon_code: coupon,
                    })
                    setHasTracked(true)
                }, 1000)
            }
        }
    }, [hasTracked])

    useEffect(() => {
        if (isAdst) {
            handleRadioClick(false)
            setCourseType(false)
        }
    }, [isAdst])

    return (
        <>
            <div
                className={`${examType !== 'MOCK-NEET' ? 'bg-light pt-2 my-3 px-4' : ''} ${
                    errors.centre ? 'pb-1' : 'pb-3'
                } ${examType === 'MOCK-JEE' ? 'd-none' : 'd-block'}`}
            >
                {examType !== 'MOCK-NEET' && (
                    <p className="mb-2 text-dark-grey font-size-xs fw-500">
                        Preferred Exam Slots
                    </p>
                )}

                <div
                    style={{ position: 'relative' }}
                    className={examType === 'MOCK-NEET' ? 'd-none' : 'd-block'}
                >
                    <SelectCreatable
                        required
                        placeholder="Exam Slots"
                        name="examSlots"
                        options={dropdownOptions.examSlots}
                        value={getSelectDefaultValue(
                            examInfo.examSlots,
                            dropdownOptions.examSlots,
                            'label',
                        )}
                        onChange={handleOnChange}
                        onErrorUpdate={handleUpdateErrors}
                        messages={{
                            required: 'Please select exam slot',
                        }}
                        isSearchable={false}
                        // Hide dropdown arrow, separator, and clear (×)
                        components={
                            dropdownOptions.examSlots?.length === 1
                                ? {
                                      DropdownIndicator: () => null,
                                      IndicatorSeparator: () => null,
                                      ClearIndicator: () => null,
                                  }
                                : undefined
                        }
                        outerDivStyles={`w-100 font-size-sm rounded box-shadow-none ${
                            errors.centre ? `border-0` : `border border-grey-100`
                        }`}
                        placeholderStyles={{ color: '#545454' }}
                        borderStyles={`2px solid #00b0f5 !important`}
                        style={{
                            color: '#212529!important',
                            fontWeight: 'normal !important',
                            fontSize: '13px',
                            lineHeight: '30px',
                            cursor: 'default',
                        }}
                        disabled={isSfNewUser}
                    />

                    {/* Transparent overlay (prevents click but looks normal) */}
                    {dropdownOptions.examSlots?.length === 1 && (
                        <div
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                cursor: 'default',
                                background: 'transparent',
                            }}
                        ></div>
                    )}
                </div>
            </div>
            {courseType &&
                ((!!examInfo.examSlots &&
                    examInfo?.examSlots?.label.startsWith('Offline')) ||
                    examType != 'IAT') && (
                    <div
                        className={`bg-light pt-2 my-3 px-4 ${
                            errors.centre ? 'pb-1' : 'pb-3'
                        } ${examType === 'MOCK-JEE' ? 'd-none' : 'd-block'}`}
                    >
                        <p
                            className="mb-2 text-dark-grey font-size-xs fw-500"
                            style={{
                                marginTop: '-8%',
                            }}
                        >
                            {['IAT', 'MOCK-NEET', 'MOCK-JEE'].includes(getExamType())
                                ? 'Preferred Aakash Center For Exam'
                                : 'Preferred Aakash Centre for Coaching'}
                        </p>
                        <div>
                            <SelectCreatable
                                required
                                placeholder="Select State"
                                name="state"
                                options={dropdownOptions.state}
                                value={getSelectDefaultValue(
                                    examInfo.state,
                                    dropdownOptions.state,
                                    'shortCode',
                                )}
                                onChange={handleOnChange}
                                onErrorUpdate={handleUpdateErrors}
                                messages={{
                                    required: !examInfo.examSlots
                                        ? 'Please select exam slot first'
                                        : 'Please select state',
                                }}
                                isSearchable={true}
                                className="mb-3 mt-2"
                                outerDivStyles={`mb-0 w-100 font-size-sm rounded box-shadow-none ${
                                    errors.state
                                        ? `border-0`
                                        : `border border-grey-100`
                                }`}
                                placeholderStyles={{ color: '#545454' }}
                                borderStyles={`2px solid #00b0f5 !important`}
                                style={{
                                    color: '#212529!important',
                                    fontWeight: 'normal !important',
                                }}
                                disabled={isSfNewUser}
                            />
                            <SelectCreatable
                                required
                                placeholder="Select Centre"
                                name="centre"
                                options={dropdownOptions.centre}
                                value={getSelectDefaultValue(
                                    examInfo.centre,
                                    dropdownOptions.centre,
                                    'label',
                                )}
                                onChange={handleOnChange}
                                onErrorUpdate={handleUpdateErrors}
                                messages={{
                                    required: !examInfo.state
                                        ? 'Please select state first'
                                        : !examInfo.classStream
                                          ? 'Please select class & stream'
                                          : checkMock == true
                                            ? 'No seats available in selected state.'
                                            : 'Please select centre',
                                }}
                                isSearchable={true}
                                outerDivStyles={`w-100 font-size-sm rounded box-shadow-none ${
                                    errors.centre
                                        ? `border-0`
                                        : `border border-grey-100`
                                }`}
                                placeholderStyles={{ color: '#545454' }}
                                borderStyles={`2px solid #00b0f5 !important`}
                                style={{
                                    color: '#212529!important',
                                    fontWeight: 'normal !important',
                                }}
                                disabled={isSfNewUser}
                            />
                        </div>
                    </div>
                )}
            {courseType && examType == 'IAT' && (
                <div
                    className={`bg-light pt-2 my-3 px-4 ${
                        errors.centre ? 'pb-1' : 'pb-3'
                    } ${examType === 'MOCK-JEE' ? 'd-none' : 'd-block'}`}
                >
                    <p className="mb-2 text-dark-grey font-size-xs fw-500">
                        Preferred Coaching Center
                    </p>
                    <div>
                        <SelectCreatable
                            required
                            placeholder="Select State"
                            name="coachingState"
                            options={dropdownOptions.coachingStates}
                            value={getSelectDefaultValue(
                                examInfo.coachingState,
                                dropdownOptions.coachingStates,
                                'shortCode',
                            )}
                            onChange={handleOnChange}
                            onErrorUpdate={handleUpdateErrors}
                            messages={{
                                required: !examInfo.examSlots
                                    ? 'Please select exam slot first'
                                    : 'Please select state',
                            }}
                            isSearchable={true}
                            className="mb-3 mt-2"
                            outerDivStyles={`mb-0 w-100 font-size-sm rounded box-shadow-none ${
                                errors.state ? `border-0` : `border border-grey-100`
                            }`}
                            placeholderStyles={{ color: '#545454' }}
                            borderStyles={`2px solid #00b0f5 !important`}
                            style={{
                                color: '#212529!important',
                                fontWeight: 'normal !important',
                            }}
                            disabled={isSfNewUser}
                        />
                        <SelectCreatable
                            required
                            placeholder="Select Centre"
                            name="coachingBranch"
                            options={dropdownOptions.coachingBranches}
                            value={getSelectDefaultValue(
                                examInfo.coachingBranch,
                                dropdownOptions.coachingBranches,
                                'label',
                            )}
                            onChange={handleOnChange}
                            onErrorUpdate={handleUpdateErrors}
                            messages={{
                                required: !examInfo.coachingState
                                    ? 'Please select state first'
                                    : !examInfo.classStream
                                      ? 'Please select class & stream'
                                      : checkMock == true
                                        ? 'No seats available in selected state.'
                                        : 'Please select centre',
                            }}
                            isSearchable={true}
                            outerDivStyles={`w-100 font-size-sm rounded box-shadow-none ${
                                errors.centre ? `border-0` : `border border-grey-100`
                            }`}
                            placeholderStyles={{ color: '#545454' }}
                            borderStyles={`2px solid #00b0f5 !important`}
                            style={{
                                color: '#212529!important',
                                fontWeight: 'normal !important',
                            }}
                            disabled={isSfNewUser}
                        />
                    </div>
                </div>
            )}
            {/* Due to error exist on the coursetype toggle for DateofExam on Single Component that's why use seperate Select Box for date of Exam for coursetype toogle */}
            {/* Date of Exam */}
            {courseType && (
                <SelectCreatable
                    required
                    placeholder="Date of exam (DD/MM/YYYY)"
                    name="dateOfExam"
                    options={dropdownOptions.dateOfExam}
                    value={getSelectDefaultValue(
                        examInfo.dateOfExam,
                        dropdownOptions.dateOfExam,
                    )}
                    onChange={handleOnChange}
                    onErrorUpdate={handleUpdateErrors}
                    messages={{
                        required: !examInfo.centre
                            ? 'Please select centre first'
                            : !examInfo.classStream
                              ? 'Please select class & stream'
                              : 'Please select date of exam',
                    }}
                    isSearchable={false}
                    className="mb-3 px-4"
                    outerDivStyles={`w-100 font-size-sm rounded box-shadow-none ${
                        errors.dateOfExam ? `border-0` : `border border-grey-100`
                    } ${examType === 'MOCK-JEE' ? 'd-none' : 'd-block'}`}
                    placeholderStyles={{ color: '#545454' }}
                    borderStyles={`2px solid #00b0f5 !important`}
                    style={{
                        color: '#212529!important',
                        fontWeight: 'normal !important',
                        display: examType == 'MOCK-JEE' ? 'none' : 'block',
                    }}
                    disabled={isSfNewUser}
                />
            )}
            {!courseType && (
                <SelectCreatable
                    required
                    placeholder="Date of exam (DD/MM/YYYY)"
                    name="dateOfExam"
                    options={dropdownOptions.dateOfExam}
                    value={getSelectDefaultValue(
                        examInfo.dateOfExam,
                        dropdownOptions.dateOfExam,
                    )}
                    onChange={handleOnChange}
                    onErrorUpdate={handleUpdateErrors}
                    messages={{
                        required: !examInfo.centre
                            ? 'Please select centre first'
                            : !examInfo.classStream
                              ? 'Please select class & stream'
                              : 'Please select date of exam',
                    }}
                    isSearchable={false}
                    className="mb-3 px-4"
                    outerDivStyles={`w-100 font-size-sm rounded box-shadow-none ${
                        errors.dateOfExam ? `border-0` : `border border-grey-100`
                    }`}
                    placeholderStyles={{ color: '#545454' }}
                    borderStyles={`2px solid #00b0f5 !important`}
                    style={{
                        color: '#212529!important',
                        fontWeight: 'normal !important',
                        fontSize: '14px',
                    }}
                    disabled={isSfNewUser}
                />
            )}

            {!partialData?.data?.isPaidExam && (
                <div className="px-4 pb-2">
                    <Button
                        className={cx(
                            `btn btn-aqua text-white w-10 fw-700 font-size-mds font-size-lg-lg ${styles.reg_custom_btn} ${styles.sendOtpButton}`,
                            {
                                'bg-grey-20 text-grey-70 border-0':
                                    isSubmitBtnDisabled,
                            },
                        )}
                        onClick={handleSubmitIacst}
                        disabled={isSubmitBtnDisabled || isSignupLoading}
                    >
                        {isSignupLoading ? Loader : 'Submit'}
                    </Button>
                </div>
            )}

            {partialData?.data?.isPaidExam && (
                <>
                    <div className={`px-4 ${styles.payment_section}`}>
                        {partialData?.data?.isCouponApplicable != 0 && (
                            <ApplyCoupon
                                partialData={partialData}
                                setRemoveCoupon={setRemoveCoupon}
                                setCouponCode={setCouponCode}
                                setCoupon={setCoupon}
                            />
                        )}

                        <div>
                            <div
                                className={
                                    examType === 'IAT' ? styles.invictus_topay : ''
                                }
                            >
                                <div className="d-flex justify-content-between align-items-center">
                                    {(examType === 'MOCK-NEET' ||
                                        examType === 'MOCK-JEE') && (
                                        <span className={`${styles.exam_fee}`}>
                                            Exam fees
                                        </span>
                                    )}
                                    {examType === 'IAT' && (
                                        <span className={`${styles.exam_fee}`}>
                                            To Pay
                                        </span>
                                    )}

                                    <span className={`${styles.exam_amount}`}>
                                        {removeCoupon !== 0 ? (
                                            <div className="d-flex align-items-center">
                                                <div
                                                    style={{
                                                        textDecoration:
                                                            'line-through',
                                                        marginRight: '8px',
                                                        fontSize: '16px',
                                                        color: '#A1A4A8',
                                                        fontWeight: 'normal',
                                                    }}
                                                >
                                                    ₹ {partialData.data.exam_fee}
                                                </div>
                                                <div>
                                                    ₹{' '}
                                                    {Math.max(
                                                        0,
                                                        partialData.data.exam_fee -
                                                            removeCoupon,
                                                    )}
                                                </div>
                                            </div>
                                        ) : (
                                            `₹ ${partialData.data.exam_fee}`
                                        )}
                                    </span>
                                </div>
                                <div className="font-size-xs text-grey-llight mb-4">
                                    <img src={infoicon} alt="" width={14} /> Exam
                                    fees is non-refundable
                                </div>
                            </div>

                            {partialData.data.exam_fee - removeCoupon <= 0 ? (
                                /** Show Submit button when payable amount is 0 */
                                <Button
                                    className={cx(
                                        `btn btn-aqua text-white w-10 fw-700 font-size-mds font-size-lg-lg ${styles.reg_custom_btn} ${styles.sendOtpButton}`,
                                        {
                                            'bg-grey-20 text-grey-70 border-0':
                                                isSubmitBtnDisabled,
                                        },
                                    )}
                                    onClick={handleSubmitIacst}
                                    disabled={isSubmitBtnDisabled || isSignupLoading}
                                >
                                    {isSignupLoading ? Loader : 'Submit'}
                                </Button>
                            ) : (
                                /** Show payment form and Pay button when payable amount is greater than 0 */
                                <Form
                                    onSubmit={(e) => {
                                        e.preventDefault()
                                        handleSubmitIacst()
                                    }}
                                >
                                    {branchPaymentData && (
                                        <div
                                                className={`w-100 px-3 py-3 bg-white text-grey-black rounded ${Object.keys(branchPaymentData?.data || {}).length === 1 ||
                                                        !examInfo?.centre ||
                                                        !examInfo?.dateOfExam
                                                        ? 'd-none'
                                                        : 'd-block'
                                                    }`}
                                        >
                                            <p className="font-size-sm text-grey-llight">
                                                Payment Methods
                                            </p>
                                            <MobilePaymentForm
                                                paymentMethod={paymentMethod}
                                                handlePaymentMethod={
                                                    handlePaymentMethod
                                                }
                                                branchPaymentData={branchPaymentData}
                                            />
                                        </div>
                                    )}
                                    <Button
                                        type="submit"
                                        className={cx(
                                            `btn btn-aqua text-white w-10 fw-700 font-size-mds font-size-lg-lg ${styles.reg_custom_btn} ${styles.sendOtpButton}`,
                                            {
                                                'bg-grey-20 text-grey-70 border-0':
                                                    isSubmitBtnDisabled,
                                            },
                                        )}
                                        disabled={
                                            isSubmitBtnDisabled || isSignupLoading
                                        }
                                    >
                                        Pay and Register Now
                                    </Button>
                                </Form>
                            )}

                            {Object.keys(filteredFormValues).length > 0 && (
                                <PaymentForm
                                    filteredFormValues={
                                        filteredFormValues.payment_data
                                    }
                                />
                            )}
                        </div>
                    </div>
                </>
            )}
        </>
    )
}

export default connect(null, mapDispatchToProps)(memo(StepThreeExamInfo))
